module.exports = __webpack_public_path__ + "assets/img/img226.57690098.png";